import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { DashboardComponent } from 'src/app/metrics/dashboard/dashboard/dashboard.component';
import { CrmOrganizationsService } from 'src/app/parameters/crm-organizations/crm-organizations.service';
import { CustomEventsService } from 'src/app/parameters/custom-events/custom-events.service.ts';
import { UsersService } from 'src/app/parameters/users/users.service';
import { MetricsService } from 'src/app/shared/services/metrics.service';

downgradedAngularModule
  .directive('angularDashboard', downgradeComponent({ component: DashboardComponent }))
  .factory('AngularCrmOrganizationsService', downgradeInjectable(CrmOrganizationsService))
  .factory('AngularMetricsService', downgradeInjectable(MetricsService))
  .factory('AngularCustomEventsService', downgradeInjectable(CustomEventsService))
  .factory('AngularUsersService', downgradeInjectable(UsersService));
